export default __webpack_public_path__ + "static/media/question.d817f39c.svg";